export default {
  projects: 'projects',
  projectDetail: 'project-detail',
  visits: 'visits',
  visitsDetail: 'visit-show',
  price: 'price',
  auditors: 'auditors',
  reports: 'reports',
  auditorDetail: 'auditor-show',
  stores: 'stores',
  storeDrilldown: 'stores-with-tag-hierarchy',
  storeDetail: 'store-show',
  map: 'map',
  dashboard: 'dashboards',
  imagesetDetail: 'imageset-detail',
  resetAuditorPassword: 'reset-auditor-password',
  sku: 'sku',
  skuDetail: 'sku-show',
  skuValidation: 'sku-validation',
  executiveView: 'executive-view',
  operations: 'operations',
  social: 'social',
  skuAvailabilityDetail: 'sku-availability-detail',
  imageNavigator: 'image-navigator',
  embededReport: 'embeded-report',
  coverage: 'coverage'
};
